import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Chip,
  IconButton,
  Tooltip
} from '@material-ui/core';
import {
  CheckCircle as ApproveIcon,
  XCircle as RejectIcon,
  Eye as ViewIcon,
  Edit as EditIcon
} from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AfiliadosListResults = ({
  regs,
  page,
  setPage,
  perPage,
  setPerPage,
  total,
  onApprove,
  onReject,
  ...rest
}) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const handleLimitChange = (event) => {
    setPerPage(event.target.value);
    setPage(1);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };

  const getPlatformColor = (platform) => {
    const colors = {
      youtube: 'error',
      instagram: 'secondary',
      tiktok: 'primary',
      facebook: 'info',
      twitter: 'default',
      website: 'success',
      other: 'default'
    };
    return colors[platform] || 'default';
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nome do Canal</TableCell>
                <TableCell>Plataforma</TableCell>
                <TableCell>Afiliado</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Data de Cadastro</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regs.map((channel) => (
                <TableRow hover key={channel.id}>
                  <TableCell>
                    <Typography color="textPrimary" variant="body1">
                      {channel.name}
                    </Typography>
                    {channel.url && (
                      <Typography color="textSecondary" variant="body2">
                        {channel.url}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={channel.platform?.toUpperCase()}
                      color={getPlatformColor(channel.platform)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Typography color="textPrimary" variant="body2">
                      {channel.user?.name || 'N/A'}
                    </Typography>
                    <Typography color="textSecondary" variant="body2">
                      {channel.user?.email || ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={channel.approved ? 'Aprovado' : 'Pendente'}
                      color={channel.approved ? 'primary' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    {moment(channel.created_at).format('DD/MM/YYYY HH:mm')}
                  </TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                      <Tooltip title="Visualizar">
                        <IconButton
                          size="small"
                          onClick={() => navigate(`/app/afiliado/${channel.id}/view`)}
                        >
                          <ViewIcon size={18} />
                        </IconButton>
                      </Tooltip>

                      {(!auth.user?.is_admin || channel.user_id === auth.user?.id) && (
                        <Tooltip title="Editar">
                          <IconButton
                            size="small"
                            onClick={() => navigate(`/app/afiliado/${channel.id}/edit`)}
                          >
                            <EditIcon size={18} />
                          </IconButton>
                        </Tooltip>
                      )}

                      {auth.user?.is_admin && !channel.approved && (
                        <>
                          <Tooltip title="Aprovar">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => onApprove(channel.id)}
                            >
                              <ApproveIcon size={18} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Rejeitar">
                            <IconButton
                              size="small"
                              color="secondary"
                              onClick={() => onReject(channel.id)}
                            >
                              <RejectIcon size={18} />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page - 1}
        rowsPerPage={perPage}
        rowsPerPageOptions={[10, 25, 50, 100]}
        labelRowsPerPage="Registros por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
        }
      />
    </Card>
  );
};

AfiliadosListResults.propTypes = {
  regs: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  setPerPage: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  onApprove: PropTypes.func,
  onReject: PropTypes.func
};

export default AfiliadosListResults;
